import React from "react"

const StepperConnector: React.FC = () => {
  return <div className="mx-1 h-2 w-full rounded-full bg-gray-200"></div>
}

export default StepperConnector
